<ng-template #leftSideHost template-host></ng-template>
<ng-template #rightSideHost template-host></ng-template>